var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-alunno-note"},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Note")]),_c('v-card-text',{domProps:{"textContent":_vm._s(_vm.student.notes)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }